import { useCallback } from 'react'
import * as React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface ConfirmDeleteChatModalProps {
  name: string
  type?: 'chat' | 'trip'
}

function ConfirmDeleteChatModal({ name, type = 'chat' }: ConfirmDeleteChatModalProps) {
  const intl = useIntl()
  const modalElement = useModalElementContext<boolean>()

  const handleClose = useCallback(() => {
    modalElement.resolve(false)
  }, [modalElement])

  const handleConfirm = useCallback(() => {
    modalElement.resolve(true)
  }, [modalElement])
  const title = type === 'trip'
    ? intl.formatMessage({
        id: '_gIY8aHg30WOkwmXpEDD',
        defaultMessage: 'Delete trip?',
        description: 'Modal title asking the user to confirm deleting a saved trip in Trip Planner',
      })
    : intl.formatMessage({
        id: '4S_YKaoaUjxbXvSsn7AK',
        defaultMessage: 'Delete chat?',
        description: 'Modal title asking the user to confirm deleting a chat in Trip Planner',
      })

  return (
    <Modal
      title={title}
      primaryActionText={intl.formatMessage({
        id: 'q78XY3lQTi64ToIDsZGw',
        defaultMessage: 'Delete',
        description: 'Primary action button to confirm deleting a chat or trip',
      })}
      secondaryActionText={intl.formatMessage({
        id: 'ObaUQtGOQbcRJP8kdVP_',
        defaultMessage: 'Cancel',
        description: 'Secondary action button to cancel deleting a chat or trip',
      })}
      onPrimaryActionClick={handleConfirm}
      onSecondaryActionClick={handleClose}
      onClose={handleClose}
      tabletHeight="auto"
    >
      <BodyText variant="medium">
        {type === 'trip' && <FormattedMessage
          id="wSWGZ0kQkNUJXCezSw-l"
          defaultMessage="Are you sure you want to delete this trip (<bold>{name}</bold>)? This action is permanent and cannot be undone."
          description="Confirmation message when deleting a saved trip with the trip name highlighted in Trip Planner"
          values={{
            name,
            bold: (chunks: React.ReactNode) => <strong key="trip-name">{chunks}</strong>,
          }}
        />}
        {type === 'chat' && <FormattedMessage
          id="YMsVJEbd3_mwFZboKy4c"
          defaultMessage="Are you sure you want to delete this chat (<bold>{name}</bold>)? This action is permanent and cannot be undone."
          description="Confirmation message when deleting a chat with the chat name highlighted in Trip Planner"
          values={{
            name,
            bold: (chunks: React.ReactNode) => <strong key="chat-name">{chunks}</strong>,
          }}
        />}
      </BodyText>
    </Modal>
  )
}

export default ConfirmDeleteChatModal
